var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('model',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}]},[_c('div',{staticClass:"captcha-wrapper"},[_c('div',{attrs:{"id":"captcha"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }